import { SiNote, SiZenn } from 'react-icons/si';
import { formatDate } from '@/lib/format';
import type { Article } from '@/lib/articles';

const SOURCE = {
  zenn: { label: 'Zenn', Icon: SiZenn },
  note: { label: 'note', Icon: SiNote },
} as const;

/** 記事カード（トップの新着とブログ一覧で共用）。Zenn は絵文字、note はサムネイルを出す */
const ArticleCard = ({ article }: { article: Article }) => {
  const { label, Icon } = SOURCE[article.source];
  return (
    <a
      href={article.url}
      target="_blank"
      rel="noopener noreferrer"
      className="panel panel-hover flex flex-row items-center gap-4 w-full p-5 group"
    >
      <div
        className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md bg-canvas border border-hairline flex items-center justify-center text-3xl sm:text-4xl overflow-hidden"
        aria-hidden
      >
        {article.thumbnail ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={article.thumbnail}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover"
          />
        ) : (
          article.emoji || '📝'
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-body sm:text-body-lg font-medium text-ink group-hover:text-accent transition-colors line-clamp-2 tracking-tight">
          {article.title}
        </h3>
        <p className="mt-2 flex items-center gap-3 text-caption text-ink-tertiary font-mono">
          <span className="inline-flex items-center gap-1.5 text-ink-subtle">
            <Icon aria-hidden className="w-3.5 h-3.5" />
            {label}
          </span>
          {formatDate(article.publishedAt)}
        </p>
      </div>
    </a>
  );
};

export default ArticleCard;
